<template>
    <div
        class="lazy-image crop-center"
        :class="additionalClass"
        v-lazy:background-image="image ? image : '/img/estate-placeholder.jpg'"
    >
        <img
            v-lazy="image ? image : '/img/estate-placeholder.jpg'"
            alt=""
        >
    </div>
</template>

<script>
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

export default {
    props: {
        additionalClass: {
            type: String,
            required: false,            
        },

        image: {
            type: String,
            required: true,
        },
    },
}
</script>